<script>
  import VirtualList from '@sveltejs/svelte-virtual-list';
  import Product from './Product.svelte';

  import { countryProducts, activeCountry, activeCategory } from '../../stores';

  let isExtended = false;

  // $: filteredCountryProducts = (isExtended || $activeCategory === null
  //   ? $countryProducts
  //   : $countryProducts.filter(product => product.category === $activeCategory)
  // ).map((p, i) => ({ ...p, rank: i + 1 }));

  $: hasExtendedButton = $countryProducts.length > 5;
  $: topProductCount =
    $countryProducts.length < 5 ? $countryProducts.length : 5;

  $: {
    // we need this in order to reset isExtended when user switchs country
    if ($activeCountry) {
      isExtended = false;
    }
  }
</script>

<style>
  .km-title {
    font-weight: 700;
    font-size: 17px;
    margin-top: 15px;
    margin-bottom: 5px;
  }

  .km-buttonwrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
  }

  .km-product-vlist {
    height: 250px;
  }

  .km-products {
    max-height: 250px;
    overflow-y: auto;
  }

  button {
    background: #f3f3f3;
    border: 1px solid #d3d3d3;
    padding: 8px 16px;
    font-family: 'axiforma';
    font-weight: 700;
    line-height: 1;
    cursor: pointer;
    border-radius: 4px !important;
    font-size: 13px;
  }

  button:focus {
    outline: none;
  }

  button:hover {
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.08);
  }
</style>

<div class="km-productlist">
  {#if $countryProducts.length > 0}
    <div class="km-title">
      Artikel-Importe
    </div>
  {/if}

  <div class="km-products">
    {#each $countryProducts as product, i}
      <Product
        isLast={i === $countryProducts.length - 1 || $countryProducts.length === 0}
        {product} />
    {/each}
  </div>
</div>
